import { roundToTwo } from '@/utils/helpers';

export const CONTRACTS = {
  REPUBLICAN: 'Republican',
  DEMOCRATIC: 'Democratic',
  TRUMP: 'Trump',
};

export const COLOR_INDEXES = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2,
};

export const PRICE_FACTORS = {
  DELTA: 0.01,
  LOW: 0.64,
  MEDIUM: 0.79,
  HIGH: 1,
};

export const COLOR_MAP = {
  GRAY: [
    { from: 0, to: PRICE_FACTORS.LOW, color: '#dddddd' },
    { from: roundToTwo(PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: PRICE_FACTORS.MEDIUM, color: '#bbbbbb' },
    { from: roundToTwo(PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: PRICE_FACTORS.HIGH, color: '#888888' },
  ],
  BLUE: [
    { from: 30, to: roundToTwo(30 + PRICE_FACTORS.LOW), color: '#8aafff' },
    { from: roundToTwo(30 + PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: roundToTwo(30 + PRICE_FACTORS.MEDIUM), color: '#5c80dc' },
    { from: roundToTwo(30 + PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: roundToTwo(30 + PRICE_FACTORS.HIGH), color: '#244999' },
  ],
  RED: [
    { from: 40, to: roundToTwo(40 + PRICE_FACTORS.LOW), color: '#ff8b98' },
    { from: roundToTwo(40 + PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: roundToTwo(40 + PRICE_FACTORS.MEDIUM), color: '#ff5865' },
    { from: roundToTwo(40 + PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: roundToTwo(40 + PRICE_FACTORS.HIGH), color: '#d22532' },
  ],
};

export const getColorForPalletteCandidate = (contractName) => {
  const name = (contractName || '').toLowerCase();
  const isRepublican = name.includes(CONTRACTS.REPUBLICAN.toLowerCase()) ||
    name.includes(CONTRACTS.TRUMP.toLowerCase());

  if (isRepublican) {
    return COLOR_MAP.RED;
  }
  return COLOR_MAP.BLUE;
};



// WEBPACK FOOTER //
// ./src/components/pages/page-election-map-new/election-map/election-map-constants.js